import { z } from '@/libs/zod';
import { isValidCEP } from '@/utils/validators/address';

export const addressSchema = z.object({
  zipCode: z
    .string()
    .min(8, 'CEP deve conter 8 dígitos')
    .max(9, 'CEP inválido')
    .refine(
      (val) => {
        const clean = val.replace(/\D/g, '');
        return clean.length === 8;
      },
      {
        message: 'CEP deve conter 8 dígitos',
      },
    )
    .refine((val) => isValidCEP(val), {
      message: 'CEP inválido',
    }),
  street: z
    .string()
    .trim()
    .min(3, 'Logradouro deve conter pelo menos 3 caracteres')
    .regex(/^[\p{L}\p{N} ,.\-/'()]+$/u, 'Caracteres inválidos'),
  number: z
    .string()
    .trim()
    .min(1, 'Número é obrigatório. Informe um número válido ou "S/N"')
    .max(15, 'Número deve conter no máximo 15 caracteres')
    .refine(
      (val) => {
        const isNumeric = /^\d+$/.test(val);
        const isSN = /^s\/n$/i.test(val) || /^sn$/i.test(val) || /^SN$/i.test(val);
        return isNumeric || isSN;
      },
      {
        message: 'Número é obrigatório. Informe um número válido ou "S/N"',
      },
    ),
  neighborhood: z
    .string()
    .trim()
    .min(3, 'Bairro deve conter pelo menos 3 caracteres')
    .regex(/^[\p{L}\p{N} ,.\-/'()]+$/u, 'Caracteres inválidos'),
  city: z
    .string()
    .trim()
    .min(3, 'Cidade deve conter pelo menos 3 caracteres')
    .regex(/^[\p{L}\p{N} ,.\-/'()]+$/u, 'Caracteres inválidos'),
  state: z
    .string()
    .trim()
    .min(2, 'Estado deve conter 2 caracteres')
    .max(2, 'Estado deve conter 2 caracteres')
    .toUpperCase(),
  complement: z.string().trim().optional(),
});

export type Address = z.infer<typeof addressSchema>;
